export default {
  setContents(state, contents) {
    state.contents = contents;
    state.loaded = true;
  }
};
